import Filter from '../helpers/Filter';
import URL from '../helpers/URL';
import Get from "../helpers/Get";

$(function () {

    if ($('#stock').length === 0)
        return;

    const filter = (new Filter('#stock'));

    filter.$.submit(function (e) {
        e.preventDefault();

        const submit = filter.$.find('[type="submit"]'),
            data = filter.data;

        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                if (typeof data[key] == 'string') {
                    if (data[key] === '')
                        delete data[key];
                } else {

                    for (let i = 0; i < data[key].length; i++) {
                        if (data[key][i] === '')
                            delete data[key][i];
                    }
                    if (data[key].length === 0 || (data[key].length === 1 && typeof data[key][0] == 'undefined'))
                        delete data[key];
                }
            }
        }

        const query = Get.serialize(data).length ? '?' + Get.serialize(data) : '';
        $.ajax({
            type: 'POST',
            url: `/ajax/filter/list/`,
            data: data,
            beforeSend: () => {
                submit.attr('disabled', 'disabled').prop('disabled', true);
            },
            success: (data) => {
                appendList(data.html);
                window.history.pushState(null, null, URL.path + query);
            },
            complete: () => {
                submit.attr('disabled', '').prop('disabled', false);
            }
        });

    });

    const appendList = (html) => $('.car-list-wrap').html(html);

});